import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {useWindowDimensions} from 'react-native';

export const useGetFlyoutWidth = () => {
  const isDesktop = useIsDesktop();

  const windowWidth = useWindowDimensions().width;

  return isDesktop ? Math.min(950, windowWidth / 2) : windowWidth;
};
